<template name="component-name">
  <div class="drawboard">
    <canvas ref="drawboard" :class="vmode" />
  </div>
</template>

<script>
export default {
  methods: {
    initialize () {
      this.$refs.drawboard.width = window.innerWidth
      this.$refs.drawboard.height = window.innerHeight
      this.ctx = this.$refs.drawboard.getContext('2d')
      this.dom = this.$refs.drawboard
    },
    setVMode (vmode) {
      this.vmode = vmode
    },
    draw (data) {
      switch (data.cmd) {
        case 0: {
          this.ctx.beginPath()
          this.ctx.strokeStyle = this.color
          this.ctx.lineWidth = this.lineWidth
          let left = data.left
          let top = data.top
          if (!this.startAt) {
            this.startAt = [left, top]
          }
          else {
            this.ctx.moveTo.apply(this.ctx, this.startAt)
            this.ctx.lineTo(left, top)
            this.startAt = [left, top]
            this.ctx.stroke()
          }
          break;
        }
        case 1: {
          this.startAt = null
          break;
        }
        case 2: {
          this.ctx.beginPath()
          this.ctx.strokeStyle = this.color
          this.ctx.lineWidth = this.lineWidth
          let left = data.left
          let top = data.top
          let bottom = data.bottom
          let right = data.right
          this.ctx.moveTo(left, top)
          this.ctx.lineTo(bottom, right)
          this.ctx.stroke()
          break;
        }
        case 4: {
          this.ctx.beginPath()
          this.ctx.strokeStyle = this.color
          this.ctx.lineWidth = this.lineWidth
          let left = data.left
          let top = data.top
          let bottom = data.bottom
          let right = data.right
          let radx = (right - left) / 2
          let rady = (bottom - top) / 2
          this.ctx.ellipse(
            left + radx, top + rady,
            Math.abs(radx), Math.abs(rady),
            0, // Math.PI / 4,
            0,
            2 * Math.PI
          )
          this.ctx.stroke()
          break;
        }
        case 5: {
          this.ctx.beginPath()
          this.ctx.strokeStyle = this.color
          this.ctx.lineWidth = this.lineWidth
          let left = data.left
          let top = data.top
          let bottom = data.bottom
          let right = data.right
          this.ctx.rect(left, top, (right - left), (bottom - top))
          this.ctx.stroke()
          console.log(`[left ${left} top ${top} bottom ${bottom} right ${right}]`)
          this.logMsg = `[left ${left} top ${top} bottom ${bottom} right ${right}]`
          break;
        }
        case 7: {
          this.ctx.clearRect(0, 0, this.dom.width, this.dom.height)
          break;
        }
        case 8: {
          this.ctx.lineWidth = this.lineWidth = data.width
          break;
        }
        case 9: {
          this.ctx.strokeStyle = this.color = '#' + data.color
          break;
        }
        case 12: {
          // SET BOARD SIZE
          this.calcSize()
          this.$refs.drawboard.width = data.top
          this.$refs.drawboard.height = data.bottom
          console.log(`[VIEWER SIZE w ${data.top} x h ${data.bottom}]`)
          break;
        }
        default: {
          console.log(data)
        }
      }
    },
    clear () {
      return this.ctx.clearRect(0, 0, this.dom.width, this.dom.height)
    },
    calcSize () {
      if (!this.video) return;
      let {clientWidth, clientHeight} = this.video
      this.$refs.drawboard.style.width = clientWidth + 'px'
      this.$refs.drawboard.style.height = clientHeight + 'px'
      console.log(`[VIDEO SIZE w ${clientWidth} x h ${clientHeight}]`)
    },
    setVideo (videoObj) {
      this.video = videoObj
    },
    getSnapshot () {
      this.ctx.save()
      this.clear()
      this.ctx.drawImage(this.video, 0, 0)
      let dataUrl = this.dom.toDataURL('image/png')
      this.clear()
      this.ctx.restore()
      return dataUrl
    }
  },
  mounted () {
    this.initialize()
  },
  data () {
    return {
      ctx: null,
      dom: null,
      color: '#ff0000',
      startAt: null,
      lineWidth: 4,
      vmode: 'vert',
      video: null,
      logMsg: ''
    }
  }
}
</script>

<style lang="scss">
  .drawboard {
    position: absolute;
    top: 0; bottom: 0; left: 0; right: 0;
    z-index: 90;
    display: flex;
    align-items: center;
    justify-content: center;

    .hori { width: 100% }
    .vert { height: 100% }
  }
</style>